module.exports = __webpack_public_path__ + "img/Live_Line_2_20px_Icon.7e1ac75a.svg";